import { TemplateConfig } from '../types';

export const giveUpSpreadConfig: TemplateConfig = {
  id: 'give-up-spread',
  name: '断舍离牌阵',
  description: '针对忘不掉某个人或感情问题的断舍离分析',
  cardCount: 5,
  
  fieldDefaults: {
    title: '断舍离牌阵',
    customerQuestion: '忘不掉某个人或是感情中出现问题，我该不该放下？',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 3 行第 1 张牌'
    ],
    cardInfos: [
      '对方目前对我的想法',
      '我应该放弃这段感情吗？为什么？',
      '我应该放弃这段感情吗？为什么？',
      '我应该放弃这段感情吗？为什么？',
      '如果我放弃了，我未来的发展会变得更好吗？'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💜'
  }
};